/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

let CODE_IV = "0123456789ABCDEF";
let CODE_KEY = "1234567890ABCDEF1234567890ABCDEf";
let baseUrl;
let uploadFileBaseUrl;//上传
let readImagePath;
let locationUrl;//项目部署url
//环境判断,设置对应的服务器地址bianjie.51vip.biz:19311
if(process.env.NODE_ENV =='production'){//生产
	baseUrl = 'http://api.ms170.cn:6060';
	//baseUrl = 'http://111.198.131.251:6060';
	//uploadFileBaseUrl = 'http://api.ms170.cn:7070/uploadFile';
	//downFileBaseUrl = 'http://api.ms170.cn:7070/fileupload';
	//baseUrl = 'http://bianjie.51vip.biz:19311';
	//locationUrl = 'http://bianjie.51vip.biz:56277';
	locationUrl = 'http://www.ms170.cn/all';
	uploadFileBaseUrl = 'http://bianjie.51vip.biz:19311/mstx/upload/form';
	readImagePath = 'http://api.ms170.cn:7070/fileupload'
}else{//测试
	baseUrl = 'http://111.198.131.251:6060';
//baseUrl = 'http://api.ms170.cn:6060';
//	baseUrl = 'http://localhost:6060';
	locationUrl = 'http://localhost:8080';
	//baseUrl = 'http://bianjie.51vip.biz:19311';
	uploadFileBaseUrl = 'http://localhost:60602/uploadFile';
	readImagePath = 'http://localhost:60602/fileupload'
}
export {
	baseUrl,
	uploadFileBaseUrl,
	readImagePath,
	locationUrl,
	CODE_IV,
	CODE_KEY
}
